import { useLocation } from 'react-router';

import { useIsWidget, useRemoveDomain } from '@app/hooks';

import { useSidebarContext } from './SidebarContext';

const isSameHost = (url: string): boolean => {
  try {
    const { host } = new URL(url, window.location.href);

    return host === window.location.host;
  } catch {
    return true;
  }
};

export const useIsActiveLink = (link: string): boolean => {
  const { isActive } = useSidebarContext();
  const { pathname } = useLocation();

  const hrefWithoutDomain = useRemoveDomain(link);
  const isWidget = useIsWidget();
  const pathnameWidget = useRemoveDomain(window.location.href);

  const pathnameToCompare = isWidget ? pathnameWidget : pathname;

  return isSameHost(link) && isActive(pathnameToCompare, hrefWithoutDomain);
};
